<template>
  <table-column-picker
    v-slot="{ headers, activatorProps }"
    :headers="documentListHeaders"
    storage-key="documents-agreement-table"
    title="Налаштування відображення переліку документів">
    <b-server-table
      :filter-props="{
        filterMap: [
          { key: 'search' },
          {
            key: 'typeId',
            directory: 'documentTypes',
            component: 'select',
          },
        ],
        scope: 'document',
      }"
      :headers="headers"
      :request-func="getDocuments"
      @click:row="
        $router.push({
          name: 'document-agreement-single',
          params: { id: $event.id },
        })
      ">
      <template #action-button>
        <div class="d-flex align-center ga-3">
          <table-column-picker-button v-bind="activatorProps" />
          <v-btn
            v-if="can('document-agreements.create')"
            color="primary"
            rounded="lg"
            @click.stop="createDocument">
            <v-icon class="mr-1">mdi-plus</v-icon>
            Створити документ
          </v-btn>
        </div>
      </template>
      <template #item.created_at="{ item }">
        <span style="white-space: nowrap">
          {{ new CustomDate(item.created_at).toString({ time: true }) }}
        </span>
      </template>
      <template #item.type="{ item }">
        {{ item.type?.name }}
      </template>
      <template #item.name="{ item }">
        <v-tooltip :text="item?.name">
          <template #activator="{ props }">
            <div class="text-truncate" style="width: 250px" v-bind="props">
              <span>
                {{ item.name }}
              </span>
            </div>
          </template>
        </v-tooltip>
      </template>
      <template #item.number="{ item }">
        <span style="white-space: nowrap">
          {{ item.number }}
        </span>
      </template>
      <template #item.status="{ item }">
        <span style="white-space: nowrap">
          {{ item.status?.name }}
        </span>
      </template>
      <template #item.author="{ item }">
        <span style="white-space: nowrap">
          {{ getPersonName(item.author, { initials: true }) }}
        </span>
      </template>
      <template #[`item.contractors`]="{ item }">
        <v-menu>
          <template #activator="{ props }">
            <span v-if="item.contractors.length" class="link" v-bind="props">
              Показати
            </span>
            <span v-else>Відсутні</span>
          </template>
          <v-card>
            <v-card-text>
              <div
                v-for="(contractor, idx) in item.contractors"
                :key="contractor.id"
                :class="{ 'mb-2': item.contractors.length - 1 > idx }"
                class="link"
                @click.stop="
                  $router.push({
                    name: 'single-contractor',
                    params: { id: contractor?.contractorId },
                  })
                ">
                {{ contractor.contractor.name }}
              </div>
            </v-card-text>
          </v-card>
        </v-menu>
      </template>
      <template #bottom></template>
    </b-server-table>
  </table-column-picker>
</template>

<script lang="ts">
import { BServerTable } from 'best-modules/components'
import { CustomDate, getPersonName, Query } from 'best-modules/utils'
import { useRoute } from '@/plugins'
import { documentListHeaders } from '@/utils/tableHeaders'
import { useCan } from '@/composables/useCan'
import { computed } from 'vue'
import { documentAgreementList } from '@/requests/documentAgreement'
import { PaginationList } from 'best-modules/components/server-table/types'
import { DocumentAgreement } from '@/utils/types/documentAgreement'
import { openDialog } from '@/dialog'
import { useRouter } from 'vue-router'
import TableColumnPicker from '@/components/TableColumnPicker.vue'
import TableColumnPickerButton from '@/components/buttons/TableColumnPickerButton.vue'

export default {
  name: 'DocumentAgreementList',
  components: { TableColumnPickerButton, TableColumnPicker, BServerTable },
  data() {
    return { documentListHeaders }
  },
  methods: { CustomDate, getPersonName },
  setup() {
    const route = useRoute()
    const router = useRouter()
    const { can } = useCan()

    const listQuery = computed(() => {
      switch (route.name) {
        case 'document-agreement-new':
          return (query = {}) => ({ ...query, statusId: 1 })
        case 'document-agreement-revision':
          return (query = {}) => ({ ...query, statusId: 2 })
        case 'document-agreement-me':
          return (query = {}) => ({ ...query, statusId: 3 })
        case 'document-agreement-agreed':
          return (query = {}) => ({ ...query, statusId: 4 })
        default:
          return (query = {}) => query
      }
    })

    const getDocuments = (
      query: Query
    ): Promise<PaginationList<DocumentAgreement>> => {
      return documentAgreementList(listQuery.value(query))
    }

    const createDocument = () => {
      openDialog({
        name: 'Document',
        action: 'create',
        params: {
          cb: document => {
            router.push({
              name: 'document-agreement-single',
              params: { id: document.id },
            })
          },
          submitLabel: 'Створити договір',
        },
      })
    }

    return {
      getDocuments,
      createDocument,
      can,
    }
  },
}
</script>

<style lang="scss" scoped></style>
